export default {
  input: 'w-[calc(100vw-40px)] md:w-[350px] lg:w-[409px] max-w-[409px]',
  inputsWrapper: 'flex flex-col gap-[24px]',
  otpContainer: 'flex justify-between gap-1 sm:gap-2 w-[calc(100vw-40px)] md:w-[350px] lg:w-[409px] max-w-[409px]',
  otpInput: 'w-1/6 py-2 sm:py-3 border border-[#CCDCE8] rounded-lg font-interMedium text-[18px] sm:text-[24px] text-center',
  textWrapper: 'flex gap-[8px]',
  text: 'font-inter text-base text-[#585D69]',
  sendAgain: 'font-interSemibold text-base text-[#00518B]',
  cursor: 'cursor-pointer',
  infoText: 'w-[calc(100vw-40px)] md:w-[350px] lg:w-[409px] max-w-[409px] text-[14px] text-color-text-grey mt-[4px]',
  backLink: 'flex items-center cursor-pointer mb-[16px] max-w-fit',
  backLinkText: 'ml-[4px]',
};
